import { Component } from '@angular/core';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import { DataTableColumnIcon } from '../../../../components/widgets/data-table/columns/data-table-column-icon/data-table-column-icon.config';
import { AntivirusFileUploadLogService } from '../../../../services/api/antivirus-file-upload-log.service';
import { RouteService } from '../../../../services/route.service';

@Component({
  selector: 'app-antivirus-log-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './antivirus-log-index-page.component.html',
  styleUrl: './antivirus-log-index-page.component.scss'
})
export class AntivirusLogIndexPageComponent {
  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected antivirusFileUploadLogService: AntivirusFileUploadLogService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Antivirus File upload log list',
      cardTitle: 'Antivirus File upload log',
      dataTable: {
        data: [],
        searchModel: {
          user: null,
          section: null,
          category: null,
          referTable: null,
          referId: null,
          fileNameOriginal: null,
          mimeType: null,
          antivirusResult: null,
          status: null,
          createTime: null
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'antivirusLogId',
            header: 'ID',
            width: '60px',
            filter: 'text',
            value: (item: any) => item.antivirusLogId
          }),
          new DataTableColumnText({
            attribute: 'userFullName',
            header: 'USER',
            filter: 'text',
            value: (item: any) => item.user ? `${item.user.firstName} ${item.user.lastName}` : ''
          }),
          new DataTableColumnText({
            attribute: 'section',
            header: 'SECTION',
            filter: 'text',
            value: (item: any) => item.section
          }),
          new DataTableColumnText({
            attribute: 'category',
            header: 'CATEGORY',
            filter: 'text',
            value: (item: any) => item.category
          }),
          new DataTableColumnText({
            attribute: 'referTable',
            header: 'REFER TABLE',
            filter: 'text',
            value: (item: any) => item.referTable
          }),
          new DataTableColumnText({
            attribute: 'referId',
            header: 'REFER ID',
            width: '80px',
            filter: 'text',
            value: (item: any) => item.referId
          }),
          new DataTableColumnText({
            attribute: 'fileNameOriginal',
            header: 'FILE NAME ORIGINAL',
            filter: 'text',
            value: (item: any) => item.fileNameOriginal
          }),
          new DataTableColumnText({
            attribute: 'mimeType',
            header: 'MIME TYPE',
            filter: 'text',
            value: (item: any) => item.mimeType
          }),
          new DataTableColumnIcon({
            attribute: 'antivirusResult',
            header: 'VIRUS',
            width: '70px',
            filter: 'select',
            filterOptionsSource: 'boolean',
            value: (item: any) => {
              if (item.antivirusResult === 1 || item.antivirusResult === 2) {
                return 'fa fa-exclamation-triangle text-danger';
              } else if (item.antivirusResult === 0) {
                return 'fa fa-shield text-success';
              } else {
                return 'fa fa-question text-secondary';
              }
            }
          }),
          new DataTableColumnText({
            attribute: 'status',
            header: 'STATUS',
            filter: 'select',
            filterOptionsSource: 'antivirusLogStatus',
            value: (item: any) => item.status
          }),
          new DataTableColumnText({
            attribute: 'createTime',
            header: 'CREATE TIME',
            value: (item: any) => item.createTime
          }),
          new DataTableColumnActions({
            attribute: 'actions',
            header: 'ACTIONS',
            width: '80px',
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View Detail',
                onClick: (item: any) => {
                  this.routeService.antivirusLogDetail(item.antivirusLogId);
                }
              }
            ]
          })
        ]
      }, 
      apiListService: (options: any) => this.antivirusFileUploadLogService.list(options),
      responseListModelName: 'antivirusLogs',
    };
  }
}
